import { coreTagsIdMapRemoveSlice } from './remove';
import { coreTagsIdMapSlice } from './update';

export const removeTagReference = coreTagsIdMapRemoveSlice.syncActionCreator;
export const updateTagReferences = coreTagsIdMapSlice.syncActionCreator;
